export default __webpack_public_path__ + "static/media/zawodniczka6.c8896ad1.png";